import React from "react";
import { useTranslation } from "react-i18next";

const FormTitleMain = ({ title = "" }) => {
  const { t } = useTranslation();
  return <h6 className="mb-0">{title || t("global.basicInfo")}</h6>;
};

export default FormTitleMain;
